import r from "./Trap.js";
import { mediumSidecar as m } from "./medium.js";
import { exportSidecar as o } from "../../../use-sidecar/dist/es2015/exports.js";
o(m, r);
//# sourceMappingURL=sidecar.js.map
